import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getBuyingPortfolio } from 'utils';

type SessionLinkProps = {
  listingEnquiryId: string;
  sessionId: string;
};

const SessionLink: React.FC<SessionLinkProps> = ({
  listingEnquiryId,
  sessionId,
}) => {
  const { t } = useTranslation();

  return (
    <Link
      className="ncoded-button ncoded-button--solid"
      to={`${getBuyingPortfolio(listingEnquiryId, 'messaging')}/${sessionId}`}
    >
      {t('chatWithBroker')}
    </Link>
  );
};

export default SessionLink;
